import { Component, OnInit } from '@angular/core';
declare var $;
import {Location} from '@angular/common';
@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss']
})
export class AgentsComponent implements OnInit {

  constructor(private _location: Location) {
    console.log('agent loaded');
   }

  ngOnInit() {
    window.dispatchEvent(new Event('resize'));
    $('body').addClass('hold-transition skin-blue sidebar-mini');
  }

  backClicked() {
    this._location.back();
  }

}
